import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ApiService } from '../services/api.service';

import { CookieService } from 'ngx-cookie-service';

import { Role } from '../model/role';

import { AreaData } from '../model/area.model';

@Component({

  selector: 'app-login',

  templateUrl: './login.component.html',

  styleUrls: ['./login.component.scss'],

})

export class LoginComponent implements OnInit {

  loginForm: FormGroup;

  invalidLogin: boolean = false;

  constructor(

    private formBuilder: FormBuilder,

    private router: Router,

    private apiService: ApiService    ,

    private cookieService: CookieService

  ) {}



  onSubmit() {

    if (this.loginForm.invalid) {

      return;

    }

    const loginPayload = {

      employeeId: this.loginForm.controls.username.value,

      password: this.loginForm.controls.password.value,

    };

    /* if(this.loginForm.controls.username.value == "admin" && this.loginForm.controls.password.value =="123456"){

    this.router.navigate(['dashboard']);

    window.localStorage.setItem('token', "loggedIn");

   }*/



    this.apiService.login(loginPayload).subscribe((data) => {

       if (data.isSuccess === true) {

        let expire = new Date();

        var time = Date.now() + ((3600 * 1000) * 0.2);

        expire.setTime(time);

        this.cookieService.set('LOGIN_TOKEN',"loggedIn",expire);

        window.localStorage.setItem('loggedInUser', this.loginForm.controls.username.value);

        this.getLoggedEmployeeData();

        this.router.navigate(['dashboard']);

      } else {

        this.invalidLogin = true;

        alert('Login failed');

      }

    });

  }



    getLoggedEmployeeData(){

      const employeeId = window.localStorage.getItem("loggedInUser");

       this.apiService.getEmplyeeDetailsById(employeeId).subscribe((response) => {

            window.localStorage.setItem('loggedInEmployee', JSON.stringify(response));

            let roles = response.roles.map((role : Role)=>role.roleName);

            let areaNames = response.areas.map((area : AreaData)=> area.areaName);

            window.localStorage.setItem('areaNames', JSON.stringify(areaNames));

     });

  }

      



  ngOnInit() {

    if (this.cookieService.get('LOGIN_TOKEN').toString() == 'loggedIn') {

      this.router.navigate(['dashboard']);

    } else {

      this.cookieService.delete('LOGIN_TOKEN');

    }

    this.loginForm = this.formBuilder.group({

      username: ['', Validators.compose([Validators.required])],

      password: ['', Validators.required],

    });

  }

}

